import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Data, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { ConfirmDeleteDialogComponent } from 'src/app/gestion-usuarios/dialogs/confirm-delete-dialog.component';
import { ConfirmUpdateDialogComponent } from 'src/app/modal/confirmar-update/confirm-update-dialog/confirm-update-dialog.component';
import { ProcedimientoDinamico } from 'src/app/model/procedimiendo-dinamico';
import { Procedimiento } from 'src/app/model/procedimiento';
import { environment } from 'src/environments/environment';
import { ProcedimientosService } from '../../_services/procedimientos.service';
import { FormProcedimientoComponent, FormProcedimientoData } from './form-procedimiento/form-procedimiento.component';

@Component({
  selector: 'app-listado-procedimientos',
  templateUrl: './listado-procedimientos.component.html',
  styleUrls: ['./listado-procedimientos.component.scss']
})
export class ListadoProcedimientosComponent implements OnInit {
  displayedColumns: string[] = ['departamento.nombre', 'nombre', 'visible', 'acciones'];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private procedimientosService: ProcedimientosService,
    private router: Router,
    public dialog: MatDialog,
    private paginatorIntl: MatPaginatorIntl,
    private translate: TranslateService,
  ) {
    this.currentEnv = environment.environment;
    this.traduccionPaginator();
  }

  formFechaCierre = new UntypedFormGroup({
    fecha: new UntypedFormControl(""),
    hora: new UntypedFormControl(""),
  })

  formFechaApertura = new UntypedFormGroup({
    fecha: new UntypedFormControl(""),
    hora: new UntypedFormControl(""),
  })

  ngOnInit(): void {
    this.getProcedimientos();
  }

  /** GMU: los trámites se crean ocultos para el ciudadano (visible=false). */
  readonly esGmu = environment.environment === 'gmu';

  procedimientos: Array<any> = [];
  procedimientosVisibles: any = [];
  dataSource = new MatTableDataSource<Procedimiento>();
  currentEnv: string;

  get totalProcedimientos(): number { return this.dataSource?.data?.length || 0; }
  get procedimientosActivos(): number {
    return (this.dataSource?.data || []).filter((p: any) => p.visible).length;
  }
  get procedimientosInactivos(): number {
    return this.totalProcedimientos - this.procedimientosActivos;
  }


  async getProcedimientos() {
    await this.procedimientosService.getProcedimientos().subscribe({
      next: (data) => {

        this.procedimientos = data['Procedimiento'];
        this.procedimientos = this.procedimientos.filter(procedimiento => procedimiento.fechaBaja == null);
        this.dataSource = new MatTableDataSource(this.procedimientos)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'departamento.nombre': return item.departamento.nombre;
            default: return item[property];
          }
        }
        this.dataSource.sort = this.sort;
      },
      error: (err) => {
        //console.log(err);
      }
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  updateVisibility(id: number) {
    return this.procedimientosService.updateVisibilityProc(id).subscribe({
      next: (data) => {
      },
      error: (err) => {
      }
    })
  }

  updateCierre(id: number) {
    const formData = new FormData();
    formData.append('fecha', `${this.formFechaCierre.value.fecha}T${this.formFechaCierre.value.hora}:00`);
    this.procedimientosService.updateCierreProc(id, formData).subscribe({
      next: (data) => {
        this.refresh();
      },
      error: (err) => {
        //console.log(err);
      }
    });
  }

  updateApertura(id: number) {
    const formData = new FormData();
    formData.append('fecha', `${this.formFechaApertura.value.fecha}T${this.formFechaApertura.value.hora}:00`);
    this.procedimientosService.updateAperturaProc(id, formData).subscribe({
      next: (data) => {

      },
      error: (err) => {

        //this.update = false;
      }
    });
  }

  openDeleteDialog(procedimiento: Procedimiento) {
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: this.translate.instant('PROCEDIMIENTOS.MSG.DELETE_TITLE'),
        message: this.translate.instant('PROCEDIMIENTOS.MSG.DELETE_MSG', { nombre: procedimiento.nombre }),
        confirmLabel: this.translate.instant('COMMON.DELETE')
      },
      panelClass: 'gu-dialog-panel'
    });
    return ref.afterClosed().subscribe((ok) => {
      if (!ok) return;
      this.borrarProcedimiento(procedimiento.id).then(() => {
        this.reloadToMenuOption();
      });
    });
  }

  async borrarProcedimiento(id: Number) {
    await firstValueFrom(this.procedimientosService.borrarProcedimiento(id)).then((data) => {

    });
  }


  openDialog(procedimiento: Procedimiento): void {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = procedimiento
    const dialogRef = this.dialog.open(EditProcedimientosDialog, dialogConfig)

  }

  openFormProcedimiento(procedimiento: ProcedimientoDinamico | null, isEdit: boolean): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.width = '40vw';
    dialogConfig.minWidth = '600px';
    dialogConfig.maxHeight = '90vh';
    const data: FormProcedimientoData = {
      procedimiento: procedimiento,
      isEdit: isEdit
    };
    dialogConfig.data = data;

    const dialogRef = this.dialog.open(FormProcedimientoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        this.getProcedimientos();
      }
    });
  }

  openNuevoProcedimiento(): void {
    this.openFormProcedimiento(null, false);
  }

  openEditarProcedimiento(procedimiento: ProcedimientoDinamico): void {
    this.openFormProcedimiento(procedimiento, true);
  }

  openCopiarProcedimiento(procedimiento: ProcedimientoDinamico): void {
    // Crear una copia del procedimiento sin el ID para que se cree uno nuevo
    const procedimientoCopia: ProcedimientoDinamico = {
      ...procedimiento,
      id: undefined,
      nombre: procedimiento.nombre + ' (Copia)',
      fechaAlta: undefined,
      fechaModificacion: undefined,
      fechaBaja: undefined
    };
    this.openFormProcedimiento(procedimientoCopia, false);
  }

  refresh() {
    this.procedimientosService.getProcedimientos().subscribe((data: Procedimiento[]) => {
      this.dataSource.data = data;
    });
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.scrollTop();
    if (this.currentEnv == 'emvs') {
      this.router.navigate(['/admin'], { queryParams: { action: 10 } });
    } else {
      this.router.navigate(['/admin'], { queryParams: { action: 10 } });
    }

  }
  private traduccionPaginator(): void {
    this.paginatorIntl.itemsPerPageLabel = "Registros por página";
    this.paginatorIntl.firstPageLabel = '';
    this.paginatorIntl.previousPageLabel = '';
    this.paginatorIntl.nextPageLabel = '';
    this.paginatorIntl.lastPageLabel = '';
    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
  }

  cargarMas() {
    const newSize = this.paginator.pageSize + 10;
    this.paginator.pageSize = newSize;
    this.dataSource.paginator = this.paginator;
  }
}
@Component({
  selector: "dialog-editProcedimiento-dialog",
  templateUrl: "./dialog-editProcedimientos-dialog.html",
  styleUrls: ['./dialog-editProcedimientos-dialog.scss']
})
export class EditProcedimientosDialog {

  constructor(public dialogRef: MatDialogRef<EditProcedimientosDialog>
    , @Inject(MAT_DIALOG_DATA) public procedimiento: any,
    private router: Router,
    public dialog: MatDialog,
    private procedimientosService: ProcedimientosService,
    private datePipe: DatePipe

  ) {
    this.currentEnv = environment.environment;
  }

  isVisible = this.procedimiento.visible;
  fechaAperturaIncompletaWarning: boolean = false;
  fechaCierreIncompletaWarning: boolean = false;
  formData: FormData;
  apertura: any = "";



  currentEnv: string;

  formUpdate: UntypedFormGroup = new UntypedFormGroup({
    nombre: new UntypedFormControl(""),
    fechaApertura: new UntypedFormControl(this.apertura),
    horaApertura: new UntypedFormControl(""),
    fechaCierre: new UntypedFormControl(""),
    horaCierre: new UntypedFormControl(""),
  })

  ngOnInit() {
    this.cargarFechaEnForm(this.procedimiento.fechaApertura, 'fechaApertura', 'horaApertura');
    this.cargarFechaEnForm(this.procedimiento.fechaCierre, 'fechaCierre', 'horaCierre');
  }

  private cargarFechaEnForm(fecha: any, campoFecha: string, campoHora: string) {
    if (!fecha) return;
    const pad = (n: number) => String(n).padStart(2, '0');
    const year = fecha[0];
    const month = pad(fecha[1]);
    const day = pad(fecha[2]);
    const hour = pad(fecha[3]);
    const minute = pad(fecha[4]);
    this.formUpdate.patchValue({
      [campoFecha]: `${year}-${month}-${day}`,
      [campoHora]: `${hour}:${minute}`,
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  updateApertura(id: number) {

  }
  updateCierre(id: number) {
  }

  updateVisibility(ob: { checked: boolean }) {
    this.isVisible = ob.checked;
  }

  async openDialog(): Promise<Data> {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = { titulo: "actualización" }

    this.formData = this.comprobarDatos()

    if (!this.fechaAperturaIncompletaWarning && !this.fechaCierreIncompletaWarning) {
      const dialogRef = this.dialog.open(ConfirmUpdateDialogComponent, dialogConfig);
      return dialogRef.afterClosed().subscribe(result => {
        if (result.result == 'Confirmar') {
          this.updateProcedimiento(this.procedimiento.id)
        }
      })
    } else {
      return null;
    }

  }

  updateProcedimiento(id: Number) {
    if (!this.fechaAperturaIncompletaWarning && !this.fechaCierreIncompletaWarning) {
      this.procedimientosService.updateProcedimiento(id, this.formData).subscribe({
        next: (data) => {
          this.reloadToMenuOption();
          this.onNoClick();
        },
        error: (err) => {
          //this.update = false;
        }
      });
    }
  }

  private comprobarDatos() {
    var datestr;
    const formData = new FormData();
    if (this.formUpdate.value.nombre != "") {
      formData.append('nombre', this.formUpdate.value.nombre);
    } else {
      formData.append('nombre', this.procedimiento.nombre);
    }

    this.comprobarFechaApertura(formData);

    this.comprobarFechaCierrre(formData);

    formData.append('visible', this.isVisible);
    return formData;
  }

  private comprobarFechaCierrre(formData: FormData) {
    var datestr;
    if (this.formUpdate.value.fechaCierre != "" && this.formUpdate.value.horaCierre != "") {
      formData.append('fechaCierre', `${this.formUpdate.value.fechaCierre}T${this.formUpdate.value.horaCierre}:00`);
      this.fechaCierreIncompletaWarning = false;
    } else if ((this.formUpdate.value.fechaCierre != "" && this.formUpdate.value.horaCierre == "") || (this.formUpdate.value.fechaCierre == "" && this.formUpdate.value.horaCierre != "")) {
      this.fechaCierreIncompletaWarning = true;
    } else if (this.procedimiento.fechaCierre) {

      datestr = this.procedimiento.fechaCierre[0] + '-' + (this.procedimiento.fechaCierre[1] < 10 ? '0' + this.procedimiento.fechaCierre[1] : this.procedimiento.fechaCierre[1]) + '-' + (this.procedimiento.fechaCierre[2] < 10 ? '0' + this.procedimiento.fechaCierre[2] : this.procedimiento.fechaCierre[2]) + 'T' + (this.procedimiento.fechaCierre[3] < 10 ? '0' + this.procedimiento.fechaCierre[3] : this.procedimiento.fechaCierre[3]) + ':' + (this.procedimiento.fechaCierre[4] < 10 ? '0' + this.procedimiento.fechaCierre[4] : this.procedimiento.fechaCierre[4]) + ':00';
      this.fechaCierreIncompletaWarning = false;
      formData.append('fechaCierre', `${datestr}`);
    } else {
      this.fechaCierreIncompletaWarning = false;
      formData.append('fechaCierre', '');
    }
  }
  private comprobarFechaApertura(formData: FormData) {
    var datestr;
    if (this.formUpdate.value.fechaApertura != "" && this.formUpdate.value.horaApertura != "") {
      formData.append('fechaApertura', `${this.formUpdate.value.fechaApertura}T${this.formUpdate.value.horaApertura}:00`);
      this.fechaAperturaIncompletaWarning = false;
    } else if ((this.formUpdate.value.fechaApertura != "" && this.formUpdate.value.horaApertura == "") || (this.formUpdate.value.fechaApertura == "" && this.formUpdate.value.horaApertura != "")) {
      this.fechaAperturaIncompletaWarning = true;
    } else if (this.procedimiento.fechaApertura) {
      datestr = this.procedimiento.fechaApertura[0] + '-' + (this.procedimiento.fechaApertura[1] < 10 ? '0' + this.procedimiento.fechaApertura[1] : this.procedimiento.fechaApertura[1]) + '-' + (this.procedimiento.fechaApertura[2] < 10 ? '0' + this.procedimiento.fechaApertura[2] : this.procedimiento.fechaApertura[2]) + 'T' + (this.procedimiento.fechaApertura[3] < 10 ? '0' + this.procedimiento.fechaApertura[3] : this.procedimiento.fechaApertura[3]) + ':' + (this.procedimiento.fechaApertura[4] < 10 ? '0' + this.procedimiento.fechaApertura[4] : this.procedimiento.fechaApertura[4]) + ':00';
      this.fechaAperturaIncompletaWarning = false;
      formData.append('fechaApertura', `${datestr}`);
    } else {
      this.fechaAperturaIncompletaWarning = false;
      formData.append('fechaApertura', '');
    }
  }

  formatDate(date) {
    const dateFormat = date;
    let month = '' + (dateFormat[1]);
    let day = '' + dateFormat[2];
    let year = dateFormat[0];
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.scrollTop()
    if (this.currentEnv == 'emvs') {
      this.router.navigate(['/admin'], { queryParams: { action: 17 } });
    } else {
      this.router.navigate(['/admin'], { queryParams: { action: 17 } });
    }

  }
}
